import React from 'react'
import { Picture, AnchorLink } from '../../common'
import { relativeDate } from '../../../lib/utils/common'
import { common } from '../../../lib/transform/parsers/common'

const articleTypeLabels = {
  Recap: 'Report',
  Preview: 'Preview'
}

const ConditionalAnchorLink = (params) => {
  const { isReactEnabledLink, ...rest } = params
  return isReactEnabledLink ? (
    <AnchorLink { ...rest  } />
  ) : <a href={ rest.to } className={ rest.classes } name={ rest.trackingName }>{ rest.text }</a>
}

const CoverageArticle = ({
    id = '',
    headline = '',
    type = '',
    description = '',
    isReactEnabledLink = false,
    href = '',
    image = {},
    video = {},
    published = '',
    author = '',
    trackingName = ''
  }) => {

  const categoryLink = articleTypeLabels[type] ? (
    <div className="category-link">
      <ConditionalAnchorLink isReactEnabledLink={ isReactEnabledLink } to={ href } text={ articleTypeLabels[type] } />
    </div>
  ) : ''

  const allSources = [
    {
      config: [ {
        combinerOptions: {
          w: 208,
          h: 117
        }
      } ],
      mediaQuery: '(min-width: 414px)'
    },
    {
      config: [ {
        combinerOptions: {
          w: 156,
          h: 156,
          cquality: 40,
          scale: 'crop'
        },
        others: '2x'
      } ],
      mediaQuery: '(max-width: 413px)'
    }
  ]

  const thumbnailUrl = video.thumbnail || image.url
  const articleMedia = thumbnailUrl ? (
      <figure className="feed-item-figure">
        <ConditionalAnchorLink isReactEnabledLink={ isReactEnabledLink } classes={ 'img-wrap' } to={ href } name={ trackingName } text={(
            <Picture
              thumbnail = { common.getCombinerImage(thumbnailUrl) }
              imgClasses = { { lazyload : true } }
              allSources = { allSources }
            />
          )}>
        </ConditionalAnchorLink>
      </figure>
    ) : ''

  return (
      <article data-id={ id } className="news-feed-item">
        <ConditionalAnchorLink isReactEnabledLink={ isReactEnabledLink } to={ href } name={ trackingName } />
        { articleMedia }
        <div className="text-container">
          <div className="item-info-wrap">
            <div className="news-feed_item-meta">
              { categoryLink }
              <span className="timestamp" dangerouslySetInnerHTML={{ __html: relativeDate(new Date(published)) }} ></span>
              <span className="author" dangerouslySetInnerHTML={{ __html: author || '' }}></span>
            </div>
            <h1>
              <ConditionalAnchorLink isReactEnabledLink={ isReactEnabledLink } classes={ 'realStory' } to={ href } name={ trackingName } text={ headline } />
            </h1>
            <p dangerouslySetInnerHTML={{ __html : description }}></p>
          </div>
        </div>
      </article>
  )
}

const CoverageDay = ({
  label,
  params = {},
  articles = []
}) => {
  return (
    <section className="feed-section">
      <header className="comp section-header" dangerouslySetInnerHTML={{ __html: label ? ('<h1>' + label + '</h1>') : '' }}></header>
      { articles.map((article, i) => {
        return <CoverageArticle { ...article } params={ params } key={ i } />
      }) }
    </section>
  )
}


export const Coverage = ({ matchCoverage = [], params = {} }) => {
  return (
    <div>
      { matchCoverage.map((matchCoverageDay, i) => {
        return <CoverageDay key={ i } params={ params } { ...matchCoverageDay } />
      }) }
    </div>
  )
}

export default Coverage



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/Coverage.jsx